import { Link } from "react-router-dom";
import { cn } from "../../lib/format";

interface KpiCardProps {
  label: string;
  value: string | number;
  href: string;
  /** 0–100; draws a usage bar under the value. */
  meter?: number;
  meterAlert?: boolean;
  /** Small line under the value (e.g. "No limit"). */
  note?: string;
}

export default function KpiCard({
  label,
  value,
  href,
  meter,
  meterAlert,
  note,
}: KpiCardProps) {
  return (
    <Link
      to={href}
      className="flex flex-col gap-1 rounded-card bg-white p-4.5 text-ink no-underline"
    >
      <span className="text-[13px] text-muted">{label}</span>
      <span className="text-[26px] font-medium tracking-[-0.01em] sm:text-[30px]">{value}</span>
      {note && <span className="text-xs text-muted">{note}</span>}
      {meter !== undefined && (
        <div className="mt-1 h-1 overflow-hidden rounded-sm bg-line">
          <div
            className={cn("h-full", meterAlert ? "bg-tone-red-fg" : "bg-brand")}
            style={{ width: `${Math.min(100, meter)}%` }}
          />
        </div>
      )}
    </Link>
  );
}
